const distances = [
  { code: "25", value: 25 },
  { code: "50", value: 50 },
  { code: "100", value: 100 },
  { code: "200", value: 200 },
  { code: "300", value: 300 },
  { code: "500", value: 500 },
  { code: "10000", value: 10000 },
];

export { distances };



// WEBPACK FOOTER //
// ./src/data/distances.js